import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { COLOR_CARNATION } from 'popTheme';

const CheckIcon = styled.span`
  width: 0.75rem;
  height: 0.75rem;
  border: 0.125rem solid ${COLOR_CARNATION};
  border-radius: 0.1875rem;
`;

const CheckedIcon = styled(CheckIcon)`
  background: ${COLOR_CARNATION};
`;

const StyledRadio = ({ ...props }) => (
  <Radio role="radio" disableRipple icon={<CheckIcon />} checkedIcon={<CheckedIcon />} {...props} />
);

export const ChoiceInput = React.memo(({ options = [], selection = null, onChange }) => {
  const handleChange = useCallback((e) => onChange(Number(e.target.value)), [onChange]);

  return (
    <FormControl
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <RadioGroup role="radiogroup" onChange={handleChange} value={selection}>
        {options.map((option, index) => (
          <FormControlLabel
            sx={{
              flexDirection: 'row',
              gap: '1.5rem',
              height: { xs: '1.25rem', md: '1.5rem' },
              pt: { xs: '1.25rem', md: '1.5rem' },
              '& .MuiFormControlLabel-label': {
                fontWeight: 500,
              },
              '& .Mui-checked .MuiFormControlLabel-label': {
                fontWeight: 700,
              },
            }}
            control={<StyledRadio />}
            label={option.label}
            value={option.value}
            key={index}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
});

ChoiceInput.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
};
